var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {},
    [
      _c("navbar"),
      _vm._v(" "),
      _c("main", { staticClass: "main bg-light", attrs: { role: "main" } }, [
        _c(
          "div",
          {
            staticClass: "carousel slide",
            attrs: { id: "carouselExampleIndicators", "data-ride": "carousel" }
          },
          [
            _vm._m(0),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "carousel-control-prev pt-5",
                staticStyle: {
                  "border-bottom-width": "0px",
                  "border-bottom-style": "none"
                },
                attrs: {
                  href: "#carouselExampleIndicators",
                  role: "button",
                  "data-slide": "prev"
                }
              },
              [
                _c(
                  "span",
                  {
                    staticClass:
                      "flickity-prev-next-button previous bg-white row justify-content-center align-items-center",
                    staticStyle: { height: "60px", width: "60px" }
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticStyle: { height: "44px", width: "44px" },
                        attrs: { viewBox: "0 0 100 100" }
                      },
                      [
                        _c("path", {
                          staticClass: "arrow",
                          attrs: {
                            d:
                              "M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z"
                          }
                        })
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "sr-only" }, [
                  _vm._v(_vm._s(_vm.$t("top.Previous")))
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "carousel-control-next pt-5",
                staticStyle: {
                  "border-bottom-width": "0px",
                  "border-bottom-style": "none"
                },
                attrs: {
                  href: "#carouselExampleIndicators",
                  role: "button",
                  "data-slide": "next"
                }
              },
              [
                _c(
                  "span",
                  {
                    staticClass:
                      "flickity-prev-next-button next bg-white row justify-content-center align-items-center",
                    staticStyle: { height: "60px", width: "60px" },
                    attrs: { "aria-hidden": "true" }
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticStyle: { height: "44px", width: "44px" },
                        attrs: { viewBox: "0 0 100 100" }
                      },
                      [
                        _c("path", {
                          staticClass: "arrow",
                          attrs: {
                            d:
                              "M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z",
                            transform: "translate(100, 100) rotate(180) "
                          }
                        })
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "sr-only" }, [
                  _vm._v(_vm._s(_vm.$t("top.Next")))
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "bg-light py-5" }, [
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "text-center mb-5" }, [
              _c("h3", [_vm._v(_vm._s(_vm.$t("top.mytheme")))])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row justify-content-center" }, [
              _c("div", { staticClass: "col-md-9" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-6 col-lg-6" },
                    [
                      _c(
                        "router-link",
                        { staticClass: "card mb-4", attrs: { to: "order" } },
                        [
                          _c(
                            "div",
                            { staticClass: "card-body my-3 text-center" },
                            [
                              _c("i", {
                                staticClass:
                                  "far fa-3x fa-chart-bar mb-2 text-warning"
                              }),
                              _vm._v(" "),
                              _c(
                                "h5",
                                { staticClass: "mb-0 font-weight-light" },
                                [_vm._v(_vm._s(_vm.$t("top.myorder")))]
                              )
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-6 col-lg-6" },
                    [
                      _c(
                        "router-link",
                        { staticClass: "card mb-4", attrs: { to: "info" } },
                        [
                          _c(
                            "div",
                            { staticClass: "card-body my-3 text-center" },
                            [
                              _c("i", {
                                staticClass:
                                  "far fa-3x fa-user-circle mb-2 text-primary"
                              }),
                              _vm._v(" "),
                              _c(
                                "h5",
                                { staticClass: "mb-0 font-weight-light" },
                                [_vm._v(_vm._s(_vm.$t("top.mysettings")))]
                              )
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row justify-content-center" }),
            _vm._v(" "),
            _c("div", { staticClass: "row justify-content-center" })
          ])
        ])
      ]),
      _vm._v(" "),
      _c("copyright")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ol", { staticClass: "carousel-indicators" }, [
      _c("li", {
        staticClass: "active",
        attrs: {
          "data-target": "#carouselExampleIndicators",
          "data-slide-to": "0"
        }
      }),
      _vm._v(" "),
      _c("li", {
        attrs: {
          "data-target": "#carouselExampleIndicators",
          "data-slide-to": "1"
        }
      }),
      _vm._v(" "),
      _c("li", {
        attrs: {
          "data-target": "#carouselExampleIndicators",
          "data-slide-to": "2"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "carousel-inner" }, [
      _c("div", {
        staticClass: "carousel-item active carousel-img",
        staticStyle: { "background-image": "url(../../../static/img/7.jpg)" }
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "carousel-item carousel-img",
        staticStyle: { "background-image": "url(../../../static/img/9.jpg)" }
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "carousel-item carousel-img",
        staticStyle: { "background-image": "url(../../../static/img/1.jpg)" }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a4bd4e6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a4bd4e6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/operator/top.vue
// module id = null
// module chunks = 